/* @flow */
import * as React from 'react';
import { take } from 'lodash';
import Autosuggest from 'react-autosuggest';

import stringUtils from '../../utils/string';
import styles from './styles.module.scss';

type Suggestion = any;

type Props = {
  input: { onChange: (event: any) => any, value: any },
  meta: { error: string, touched: boolean },
  label?: string,
  suggestions: Array<Suggestion>,
  getSuggestionValue: (suggestion: Suggestion | null) => string,
  getSuggestionFromValue: (suggestionValue: string) => Suggestion,
  onChangeSuggestion: (suggestion: Suggestion) => any,
};

type State = {
  selectedSuggestion: Suggestion | null,
};

class FormAutosuggest extends React.Component<Props, State> {
  state = {
    selectedSuggestion: null,
  };

  getFilteredSuggestions = () => {
    const { suggestions = [], getSuggestionValue } = this.props;
    const { selectedSuggestion } = this.state;
    const selectedSuggestionValue = getSuggestionValue(selectedSuggestion);
    const filteredSuggestions = suggestions.filter(suggestion =>
      stringUtils.fuzzyMatch(getSuggestionValue(suggestion), selectedSuggestionValue)
    );
    return take(filteredSuggestions, 10);
  };

  render() {
    const {
      getSuggestionValue,
      getSuggestionFromValue,
      onChangeSuggestion,
      label,
      input: {
        onChange,
        // value
      },
      ...otherProps
    } = this.props;
    const { selectedSuggestion } = this.state;
    return (
      <label className={styles.container}>
        {label ? <div className={styles.label}>{label}</div> : null}
        <div className={styles.autosuggestContainer}>
          <Autosuggest
            {...otherProps}
            suggestions={this.getFilteredSuggestions()}
            onSuggestionsFetchRequested={() => {}}
            onSuggestionsClearRequested={() => {}}
            getSuggestionValue={value => getSuggestionValue(value) || ''}
            renderSuggestion={suggestion => (
              <div className={styles.suggestion}>{suggestion.name}</div>
            )}
            inputProps={{
              className: styles.input,
              placeholder: '',
              type: 'text',
              autoComplete: 'off',
              autoCorrect: 'off',
              autoCapitalize: 'off',
              spellCheck: 'false',
              value: getSuggestionValue(selectedSuggestion) || '',
              onChange: (event, { newValue }) => {
                if (
                  typeof newValue === 'string' &&
                  newValue !== getSuggestionValue(selectedSuggestion)
                ) {
                  const selectedSuggestion = getSuggestionFromValue(newValue);
                  this.setState({ selectedSuggestion });
                  onChangeSuggestion(selectedSuggestion);
                }
                onChange(event);
              },
            }}
            shouldRenderSuggestions={value => true}
            onSuggestionSelected={(
              event,
              { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
            ) => {
              this.setState({ selectedSuggestion: suggestion });
              onChangeSuggestion(suggestion);
              onChange(event);
            }}
          />
        </div>
      </label>
    );
  }
}

export default FormAutosuggest;
